import styled from 'styled-components';
import primitives from '@veneer/primitives';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${primitives.layout.size8}px ${primitives.layout.size5}px;
  max-width: 800px;
  margin: 0 auto;
`;

export const Header = styled.div`
  color: ${primitives.color.gray12};
  margin-bottom: ${primitives.layout.size5}px;
`;

export const Body = styled.div`
  color: ${primitives.color.gray9};
  ol {
    list-style: decimal;
    padding-left: ${primitives.layout.size6}px;
    margin-top: ${primitives.layout.size4}px;
  }
  p {
    margin-top: ${primitives.layout.size4}px;
  }
  ul {
    padding-left: ${primitives.layout.size6}px;
    margin-top: ${primitives.layout.size4}px;
    list-style-type: disc;
  }
`;
